var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Linkedin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.2751 9.5024C13.2379 8.51855 14.4916 7.8749 15.9501 7.8749C17.4817 7.8749 18.9506 8.48334 20.0336 9.56636C21.1167 10.6494 21.7251 12.1183 21.7251 13.6499V21.5249H19.6251V13.6499C19.6251 12.6752 19.2379 11.7405 18.5487 11.0513C17.8595 10.3621 16.9248 9.9749 15.9501 9.9749C14.9754 9.9749 14.0407 10.3621 13.3515 11.0513C12.6623 11.7405 12.2751 12.6752 12.2751 13.6499V21.5249H10.1751V8.3999H12.2751V9.5024ZM4.9251 6.2999C4.50738 6.2999 4.10677 6.13397 3.8114 5.8386C3.51603 5.54323 3.3501 5.14262 3.3501 4.7249C3.3501 4.30719 3.51603 3.90658 3.8114 3.61121C4.10677 3.31584 4.50738 3.1499 4.9251 3.1499C5.34281 3.1499 5.74342 3.31584 6.03879 3.61121C6.33416 3.90658 6.5001 4.30719 6.5001 4.7249C6.5001 5.14262 6.33416 5.54323 6.03879 5.8386C5.74342 6.13397 5.34281 6.2999 4.9251 6.2999ZM3.8751 8.3999H5.9751V21.5249H3.8751V8.3999Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon-linkedin.ac78c72aa36a8ab971bd72ddc95d92ed.svg";
export { ForwardRef as ReactComponent };